import React from "react";
import { Eye, EyeOff } from "lucide-react";

const Icon = ({ path, className = "w-6 h-6" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
  >
    <path d={path} />
  </svg>
);

export const PlusIcon = ({ className }) => (
  <Icon
    path="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
    className={className}
  />
);

export const UploadCloudIcon = () => (
  <Icon path="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z" />
);

export const ChevronDownIcon = ({ className }) => (
  <Icon
    path="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
    className={className}
  />
);

export const ChevronRightIcon = ({ className }) => (
  <Icon path="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" className={className} />
);

export const SearchIcon = ({ className }) => (
  <Icon
    path="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
    className={className}
  />
);

export const FilterIcon = () => (
  <Icon path="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
);

export const EditIcon = ({ className }) => (
  <Icon
    path="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
    className={className}
  />
);

export const EyeIcon = ({ className = "w-6 h-6" }) => (
  <Eye className={className} aria-hidden strokeWidth={2} />
);

export const EyeOffIcon = ({ className = "w-6 h-6" }) => (
  <EyeOff className={className} aria-hidden strokeWidth={2} />
);

export const CheckCircleIcon = () => (
  <Icon path="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 16.17l7.59-7.59L19 10l-9 9z" />
);

export const XCircleIcon = () => (
  <Icon path="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1.41 14.59L6 12l1.41-1.41L12 10.59l4.59-4.59L18 7.41 13.41 12l4.59 4.59L16.59 18 12 13.41 7.41 18 6 16.59l4.59-4.59z" />
);

export const AlertTriangleIcon = () => (
  <Icon
    path="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
    className="w-5 h-5"
  />
);

export const LogoutIcon = () => (
  <Icon path="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
);

export const ArrowUpIcon = ({ className }) => (
  <Icon
    path="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
    className={className}
  />
);

export const ArrowDownIcon = ({ className }) => (
  <Icon
    path="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z"
    className={className}
  />
);

export const MenuIcon = ({ className }) => (
  <Icon
    path="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    className={className}
  />
);

export const LocationIcon = ({ className }) => (
  <Icon
    path="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
    className={className}
  />
);

export const ServiceIcon = ({ className }) => (
  <Icon
    path="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41l-0.36,2.54c-0.59,0.24-1.13,0.56-1.62,0.94l-2.39-0.96c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"
    className={className}
  />
);

export const ArrowRightIcon = ({ className }) => (
  <Icon
    path="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z"
    className={className}
  />
);

export const TrashIcon = ({ className }) => (
  <Icon
    path="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
    className={className}
  />
);

export const UserIcon = ({ className }) => (
  <Icon
    path="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
    className={className}
  />
);

export const InfoIcon = ({ className }) => (
  <Icon
    path="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
    className={className}
  />
);

export const DownloadIcon = ({ className }) => (
  <Icon
    path="M5 20h14v-2H5v2zM12 2v12l4-4 1.41 1.41L12 17.83l-5.41-5.42L8 10l4 4V2h0z"
    className={className}
  />
);